import { compose, withHandlers, withState, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { bindActionCreators } from 'redux';
import config from '../../../../config';
import { deauthorizeInstagram, getAuthToken } from '../actions';

const buildIgAuthUrl = (token) => {
  const params = {
    enable_fb_login: 0,
    force_authentication: 1,
    client_id: config.instagram.clientId,
    redirect_uri: config.instagram.redirectUri,
    scope: config.instagram.scopes,
    response_type: 'code',
    state: token,
  };

  const searchParams = new URLSearchParams(params);
  return `${config.instagram.apiUrl}/oauth/authorize?${searchParams.toString()}`;
};

const mapStateToProps = (state, ownProps) => {
  const isBarber = ownProps.owner === 'barber';

  return {
    instagramUserId: isBarber ? state.barbers.byId[ownProps.id].instagramUserId : state.auth.user.brand.instagramUserId,
    igAuthUrl: buildIgAuthUrl(ownProps.owner, ownProps.id),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  changeFormField: change.bind(null, ownProps.owner === 'barber' ? 'barberForm' : 'brandSettings'),
}, dispatch);

const InstagramAuthContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('linked', 'setLinked', false),
  withState('isLoading', 'setIsLoading', false),
  lifecycle({
    componentDidMount() {
      this.props.setLinked(!!this.props.instagramUserId);
    },
  }),
  withHandlers({
    authorize: props => () => {
      if (props.disabled) {
        return false;
      }

      props.setIsLoading(true);
      return getAuthToken(props.owner, props.id)
        .then((token) => {
          props.setIsLoading(false);
          window.open(buildIgAuthUrl(token), '_blank');
        })
        .catch((err) => {
          props.setIsLoading(false);
          throw err;
        });
    },
    deauthorize: props => () => {
      if (props.disabled) {
        return false;
      }

      props.setIsLoading(true);
      return deauthorizeInstagram(props.owner, props.id)
        .then(() => {
          props.changeFormField('instagram', null);
          props.changeFormField('instagramUserId', null);
          props.setLinked(false);
          props.setIsLoading(false);
        })
        .catch((err) => {
          props.setIsLoading(false);
          throw err;
        });
    },
  }),
);

export default InstagramAuthContainer;
